import { render } from "./base-setting.html?vue&type=template&id=59bdd7ae&scoped=true&ts=true"
import script from "./base-setting.ts?vue&type=script&lang=ts"
export * from "./base-setting.ts?vue&type=script&lang=ts"

import "./base-setting.scss?vue&type=style&index=0&id=59bdd7ae&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bdd7ae"]])

export default __exports__